import styled from 'styled-components';
import { ApIcon, ApMenuItem, ApSimpleSearch, colors } from '@alixpartners/ui-components';

export const HeaderDropdownLabelContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const HeaderDropdownLabelText = styled.span`
  margin-right: 8px;
`;

export const ApMenuItemStyled = styled(ApMenuItem)`
  display: flex;
  align-items: center;
  padding: 8px 24px 8px 12px;
  font-size: 16px;
  
`;

export const MenuLabel = styled.div`
  max-width: 224px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const CheckIcon = styled(ApIcon)`
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
`;


export const SearchWrapper = styled.div`
  display: flex;
  padding: 8px;

  > div {
    width: 100%;
  }
`;

export const ActionsWrapper = styled.div`
  display: flex;
  border-top: 1px solid ${colors.grey3};
  padding: 8px 8px 0 8px;
`;

export const StyledSearch = styled(ApSimpleSearch)`
  border-radius: 0;
  border-color: ${colors.grey4};
  height: 40px;

  &:focus:enabled,
  & ~ button:focus:enabled {
    box-shadow: none;
  }

  &:focus,
  &:hover {
    border-color: ${colors.green2};
  }

  &:active {
    border-color: ${colors.green3};
  }

  &:disabled {
    pointer-events: none;
    color: ${colors.grey5};
    border-color: ${colors.grey2};
  }
`;

export const NoDataWrapper = styled.div`
  padding: 8px 12px;
`;
